import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { patch, post } from "../../../../utils/api";
import { ENDPOINTS } from "../../../../utils/constants";

const ActionButton = ({ endpoint, id, item, onRefresh }) => {
  const [display, setDisplay] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setDisplay(false);
      }
    };
    if (display) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [display]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDisplay(!display);
  };

  const reload = () => {
    if (onRefresh) onRefresh();
    else window.location.reload();
  };

  const handleUnpublish = () => {
    setDisplay(false);
    Swal.fire({
      title: "Emin misiniz?",
      text: "İçerik yayından kaldırılacak.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Evet, yayından kaldır!",
      cancelButtonText: "İptal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("is_published", 0);
        const res = await patch(endpoint + "/" + id + "/", formData);
        if (res?.status === 200) {
          toast.success("İçerik yayından kaldırıldı.");
          reload();
        } else {
          toast.error("Bir hata oluştu.");
        }
      }
    });
  };

  const getContentType = () => {
    if (endpoint === ENDPOINTS.ANNOUNCEMENTS) return "announcement";
    if (endpoint === ENDPOINTS.NEWS) return "news";
    if (endpoint === ENDPOINTS.PRODUCTS) return "product";
    if (endpoint === ENDPOINTS.TRACKS) return "track";
    return "announcement";
  };

  const handleRepublish = () => {
    setDisplay(false);
    Swal.fire({
      title: "Yayına Geri Al",
      html: `<p>İçerik tekrar yayına almak için <b>30 alkış</b> harcanacak ve <b>moderasyon kontrolünden</b> geçecektir.</p><p>Devam etmek istiyor musunuz?</p>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Evet, yayına al (30 alkış)!",
      cancelButtonText: "İptal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await post(ENDPOINTS.REPUBLISH_CONTENT + "/", {
            content_type: getContentType(),
            content_id: id,
          });
          if (res?.status === 200) {
            toast.success(res.data?.detail || "İçerik yayına alındı.");
            reload();
          } else {
            toast.error(res?.data?.detail || "Bir hata oluştu.");
          }
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Bir hata oluştu.");
        }
      }
    });
  };

  const handleFeature = () => {
    setDisplay(false);
    Swal.fire({
      title: "Vitrine Çıkart",
      html: `<p>Bu içeriği <b>30 gün</b> süreyle vitrine çıkarmak için <b>1000 alkış</b> harcanacak.</p><p>Devam etmek istiyor musunuz?</p>`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Evet, vitrine çıkart!",
      cancelButtonText: "İptal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await post(ENDPOINTS.FEATURE_CONTENT + "/", {
            content_type: "announcement",
            content_id: id,
          });
          if (res?.status === 200) {
            toast.success(res.data?.detail || "İçerik vitrine çıkarıldı!");
            reload();
          } else {
            toast.error(res?.data?.detail || "Bir hata oluştu.");
          }
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Bir hata oluştu.");
        }
      }
    });
  };

  const handleEdit = () => {
    setDisplay(false);
    navigate(`/app/ilan-ekle?edit=${id}`);
  };

  const isPublished = item?.is_published === true || item?.is_published === 1;
  const isFeatured = item?.is_featured === true || item?.is_featured === 1;
  const isAnnouncement = endpoint === ENDPOINTS.ANNOUNCEMENTS;

  const menuItemStyle = {
    display: "block",
    padding: "8px 16px",
    fontSize: 13,
    cursor: "pointer",
    whiteSpace: "nowrap",
    textDecoration: "none",
    color: "#ccc",
  };

  return (
    <div ref={menuRef} style={{ position: "relative" }}>
      <button
        onClick={handleSubmit}
        className="btn btn-sm no-bg"
        style={{ padding: "2px 6px", lineHeight: 1 }}
        title="İçerik Yönetimi"
      >
        <i className="fa fa-ellipsis-v" style={{ fontSize: 16 }} />
      </button>
      {display && (
        <div
          style={{
            position: "fixed",
            zIndex: 9999,
          }}
          ref={(el) => {
            if (el && menuRef.current) {
              const btn = menuRef.current.querySelector("button");
              if (btn) {
                const rect = btn.getBoundingClientRect();
                el.style.top = (rect.bottom + 4) + "px";
                el.style.left = Math.max(0, rect.right - 220) + "px";
              }
            }
          }}
        >
          <div
            style={{
              minWidth: 200,
              backgroundColor: "#1e1e2e",
              border: "1px solid #333",
              borderRadius: 6,
              boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
              overflow: "hidden",
            }}
          >
            {isPublished ? (
              <a role="button" onClick={handleUnpublish} style={{ ...menuItemStyle, color: "#ff6b6b" }}>
                <i className="fa fa-eye-slash fa-fw" /> Yayından Kaldır
              </a>
            ) : (
              <a role="button" onClick={handleRepublish} style={{ ...menuItemStyle, color: "#51cf66" }}>
                <i className="fa fa-eye fa-fw" /> Yayına Geri Al (30 alkış)
              </a>
            )}
            {isAnnouncement && isPublished && !isFeatured && (
              <a role="button" onClick={handleFeature} style={{ ...menuItemStyle, color: "#fcc419" }}>
                <i className="fa fa-star fa-fw" /> Vitrine Çıkart (1000 alkış)
              </a>
            )}
            {isAnnouncement && isFeatured && (
              <span style={{ ...menuItemStyle, color: "#02b875", cursor: "default", opacity: 0.8 }}>
                <i className="fa fa-star fa-fw" /> Vitrinde
                {item?.featured_until && (
                  <span style={{ fontSize: 10, marginLeft: 4 }}>
                    ({Math.max(0, Math.ceil((new Date(item.featured_until) - new Date()) / 86400000))} gün kaldı)
                  </span>
                )}
              </span>
            )}
            {isAnnouncement && (
              <a role="button" onClick={handleEdit} style={{ ...menuItemStyle, color: "#ccc" }}>
                <i className="fa fa-pencil fa-fw" /> Düzenle (250 alkış)
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionButton;
